import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36de54e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "row",
  style: {"gap":"5px"}
}
const _hoisted_5 = { class: "col d-flex flex-column justify-content-center align-item-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Movimientos del Cuarto Frío")
], -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row mb-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Fecha Inicio", -1))
const _hoisted_10 = { class: "col-sm-2" }
const _hoisted_11 = ["readonly"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Fecha Final", -1))
const _hoisted_13 = { class: "col-sm-2" }
const _hoisted_14 = ["readonly"]
const _hoisted_15 = { class: "row mb-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Tipo", -1))
const _hoisted_17 = { class: "col-sm-2" }
const _hoisted_18 = { selected: "" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "T",
  selected: ""
}, "Todos", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "E" }, "Entradas", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "S" }, "Salidas", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Estado", -1))
const _hoisted_23 = { class: "col-sm-2" }
const _hoisted_24 = { selected: "" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "T",
  selected: ""
}, "Todas", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Ingresadas", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "C" }, "Calculadas", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "D" }, "Despachadas", -1))
const _hoisted_29 = { class: "row mb-1" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Movimiento", -1))
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = { selected: "" }
const _hoisted_33 = ["value"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Control de Movimientos")
], -1))
const _hoisted_35 = { class: "card overflow-scroll w-100" }
const _hoisted_36 = { class: "table table-hover table-sm" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", null, "Movimiento"),
    /*#__PURE__*/_createElementVNode("th", null, "Documento"),
    /*#__PURE__*/_createElementVNode("th", null, "Guía"),
    /*#__PURE__*/_createElementVNode("th", null, "Llegada/Salida"),
    /*#__PURE__*/_createElementVNode("th", null, "Llegada/Salida"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Detalles de Movimientos")
], -1))
const _hoisted_40 = { class: "card overflow-scroll w-100" }
const _hoisted_41 = { class: "table table-hover table-sm" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Secuencia"),
    /*#__PURE__*/_createElementVNode("th", null, "Id. Pallet"),
    /*#__PURE__*/_createElementVNode("th", null, "Cant Pallets"),
    /*#__PURE__*/_createElementVNode("th", null, "Cajas/Bultos"),
    /*#__PURE__*/_createElementVNode("th", null, "Peso Kg"),
    /*#__PURE__*/_createElementVNode("th", null, "Monto"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))

import { ref, onMounted, computed, Ref } from 'vue';
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { Logctmo, Logdemo, LogTral } from '@/interface/interfaces';
 
import { flattenDiagnosticMessageText } from 'typescript';
import InCuartoFrio from './pInsert/InCuartoFrio.vue';
import ExCuartoFrio from './pImpresion/ExCuartoFrio.vue';
import { useDateTimeStore } from '@/store/dateTimeStore';



export default /*#__PURE__*/_defineComponent({
  __name: 'CtrlCuartofrio',
  setup(__props) {

 
const {success, error, question,warning} = useAlert()
const dUrl = UrlGlobal()
const search = ref('')
const options = ref('')
const dateTimeStore = useDateTimeStore()

const id_ref = ref<string | null>(null)
const de_ref = ref<string | null>(null)
const fecha_ctrl = ref<string | null>(null)
//--------------------------------------------------------------------------------------------------------------
const logctmo = ref<Array<Logctmo>>([]);

const getLogctmo = () => { 
        axios.get(dUrl.urlGlobal +'/api2/logctmo/')
            .then(response => {
                logctmo.value = response.data;
              
            //let almacen = response.data.almacen
            //let area = response.data.area

            })
            .catch(error => {
                console.error('Error buscando control de Movimientos:', error);
            });
};
//----------------------------------------------------------------
const logdemo = ref<Array<Logdemo>>([])
const getLogdemo = (id_compania: any, id_agencia: any, id_fecha: any, id_almacen: any, id_codigo: any, id_documento: any, id: any) => {
        id_ref.value = id
        fecha = id_fecha
        codigo = id_codigo
        documento = id_documento
         
        axios.get(`${dUrl.urlGlobal}/api2/logctmo/logdemo?id_compania=${id_compania}&id_agencia=${id_agencia}&id_fecha=${id_fecha}&id_almacen=${id_almacen}&id_codigo=${id_codigo}&id_documento=${id_documento}`)
        //axios.get(final)    
            .then(response => { //console.log(response.data)
                logdemo.value = response.data;
                console.log(response.data)

            })
            .catch(error => {
                console.error('Error buscando detalles de movimientos:', error);
        });
    }
//};

// Estado del formulario y la data
const formData = ref({
  fecha_inicio: '',
  fecha_final: '',
  tipo: '',
  status: '',
  codigo: '',
  nom_codigo: ''

});
//funcion de los botones y las extenciones de Insert,delete,update----------------
let fecha: any
let codigo: any
let documento: any

let btnIn = ref(false);//variable modal insert
let btnEx = ref(false);//variable para mostrar modal de update
let clickEx = ref(false)//variable para activar el click de Up
let btnCoUp = ref(false)
let clickCoUp = ref(false)

//funciones q activan el click y en el caso del insert muestran el modal
const CbtnEx = () => {
  clickEx.value = !clickEx.value
   
}
function insertPropsValue(newValue: boolean) {
  btnIn.value = newValue
  getLogctmo()
  getLogdemo("1", "1", null, "1", "1", "1", "1")
}

function ExcelPropsValue(newValue: boolean) {
  btnEx.value = newValue

  getLogctmo()
  getLogdemo("1", "1", "1", null, "1", "1", "1")
}
//--- Fun//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const Auxiliar = async() => {
    if (!id_ref.value) {
      error('Seleccione la línea que generará el auxiliar...')
      return
    }
    try {
        const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'logctmo', 
            filtro: { id:id_ref.value }});

        dataList.value = response.data;

    } catch (err: any) {
        error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
    }
    const envio_data = computed(() => ({
        fecha: dataList.value[0].fecha,
        almacen: '02',
        codigo: dataList.value[0].codigo,
        documento: dataList.value[0].documento, 
        status: dataList.value[0].status 
    }));

    try {
        const response = await axios.post(
        dUrl.urlGlobal + '/api2/AuxLogctmo_excel',
        envio_data.value,
        { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'auxiliar_logctmo.xlsx');
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        success('Se generó el Auxiliar del Movimiento', 'Auxiliar en descargas')
    } catch (error) {
        console.error('Error al generar el auxiliar:', error);
      }
}

const Despachar = async() => {
  console.log(id_ref.value)
  if (!id_ref.value) {
    error('Debe seleccionar la guía a entregar')
    return
  }

  for (let i = 0; i < logctmo.value.length; i++) {
    console.log(i)
    if (id_ref.value == logctmo.value[i].id) {
      if (logctmo.value[i].status == "D") {
        error('Este Registro ya fué Despachado... ')
        return
      }
      if (logctmo.value[i].status == "I") {
        error('Ante de Despachar debe realizar el cálculo del servicio... ')
        return
      }
      break;
    }
  }

  const result = await question(
    'Se generará la salida del Cuarto Frío... ',
    '¿Seguro desea continuar?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  axios.get(`${dUrl.urlGlobal}/api2/logctmo/salida?id=${id_ref.value}`) 
    .then(response => {
      console.log("Generado")
      getLogctmo
      getLogdemo("1", "1", null, "1", "1", "1", "1")
    })
    .catch(error => {
      console.log('Error en el Despacho:', error)
    })   

};

  //-- Funciones de Botones
const Calcular = async() => {
  console.log(id_ref.value)

  if(!id_ref.value) {
    error('Debe marcar el movimiento que va a calcular... ')
    return
  }
  
  if (formData.value.status =='D') {
    error('Este movimiento ya fué despachado...')
    return
  }

  try {
      const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'logdemo', 
          filtro: { compania:'300', agencia: '001', fecha: fecha, almacen: '02', 
              codigo: codigo, documento: documento }});

      dataList.value = response.data;

      if (dataList.value.length == 0) {
        warning('Ingreso no tiene detalles', 'No se generarán cálculos')
        return
        }

    } catch (err: any) {
        error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
    }

  const result = await question(
    'Se generarán los calculos con tarifa de Refrigeración... ',
    '¿Seguro desea continuar?'
  )

  if (!result.isConfirmed) {
    return
  }

  axios.get(`${dUrl.urlGlobal}/api2/logctmo/calculo?id=${id_ref.value}`) 
    .then(response => {
      console.log("Generado")
      
      getLogctmo()
      getLogdemo("1", "1", null, "1", "1", "1", "1")
    })
    .catch(error => {
      console.log('Error calculando:', error)
    })
}

const Entrada = () => {   
  btnIn.value = !btnIn.value
  fecha = dateTimeStore.formattedDate
   
}

const Listar = () => {
  btnEx.value = !btnEx.value
  let calcular = false
}

const Anular = () => {
  let calcular = false
}

//-----------------------------------------------------------------
// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return logctmo.value;
    } else if (options.value == 'fecha') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return logctmo.value.filter(elm => {
            return (
                elm.fecha?.toLowerCase().includes(searchTerm) ||
                elm.cliente?.toLocaleLowerCase().includes(searchTerm) ||
                elm.codigo?.toLowerCase().includes(searchTerm) ||
                elm.documento?.toLowerCase().includes(searchTerm) ||
                elm.fecha_llegada?.toLowerCase().includes(searchTerm) ||
                elm.hora_llegada?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return logctmo.value
    }
});
//-----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return logdemo.value;

    } else if (options.value == 'Logdemo') {
        const searchTerm = search.value.toLowerCase();

        return logdemo.value.filter(elm1 => {
            return (
                elm1.secuencia?.toLowerCase().includes(searchTerm) ||
                elm1.orden_produccion?.toLowerCase().includes(searchTerm) ||
                elm1.pallets?.toLowerCase().includes(searchTerm) ||
                elm1.cajas?.toLocaleLowerCase().includes(searchTerm) ||
                elm1.peso?.toLowerCase().includes(searchTerm) ||
                elm1.pallet_desp?.toLocaleLowerCase().includes(searchTerm) ||
                elm1.peso_desp?.toLocaleLowerCase().includes(searchTerm)
            );
        });
    }else{
        return logdemo.value
    }
});

//const FunClick = (fe: any, op: any, nv: any) => {
//  let fecha = fe;
//  let operador = op;
//  let numero_vuelo = nv;
   
//----------------------------------------------------------------
// Estado del formulario y la data
//const formData = ref({
//  base_datos: '',
//  tipo_base_datos: '',
//  servidor_bdatos: '',
//  hostname: '',
//  ip_address: '',
//  servicio: '',
//  puerto: '',
//  protocolo: ''
//});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
const currentIndex = ref(0);
const isEditing = ref(false);
const isSearching = ref(false);
const isInserting = ref(false);
const isDeleting = ref(false);
const canNavigate = ref(false);
const onlyRead = ref(true);
const ButtonText = ref('Conf')
const ButtonText2 = ref('Complto')
const ButtonText3 = ref('Calcula')
const ButtonText4 = ref('Anular')

// Deshabilita los botones de btn-group2 si no está en modo búsqueda o insercion
const canUseGroup2 = computed(() => isSearching.value || isInserting.value || isEditing.value || isDeleting.value);

//boton principal que controla el submit
//carga de las ayudas
const codigos = ref<any[]>([]);
onMounted( async () => {
  const responseC = await axios.get(dUrl.urlGlobal + '/api2/logtral/filter?status=A')
  codigos.value = responseC.data
    //getCarcmani();
    //getCardmani("1", "1", "1", null);
  
});

//computados de las ayudas
const descripcionCodigo = computed(() => {
  const encontrado = codigos.value.find(op => op.codigo === formData.value.codigo)
  return encontrado ? encontrado.descripcion : '' 
})

getLogctmo()
getLogdemo("1", "1", null, "1", "1", "1", null)

id_ref.value = null


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        type: "date",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.fecha_inicio) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_11), [
                        [_vModelText, formData.value.fecha_inicio]
                      ])
                    ]),
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        type: "date",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.fecha_final) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_14), [
                        [_vModelText, formData.value.fecha_final]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.tipo) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_18, _toDisplayString(formData.value.tipo), 1),
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21
                      ], 512), [
                        [_vModelSelect, formData.value.tipo]
                      ])
                    ]),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.status) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_24, _toDisplayString(formData.value.tipo), 1),
                        _hoisted_25,
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28
                      ], 512), [
                        [_vModelSelect, formData.value.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.codigo) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_32, _toDisplayString(descripcionCodigo.value), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codigos.value, (op) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: op.codigo,
                            value: op.codigo
                          }, _toDisplayString(op.descripcion), 9, _hoisted_33))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formData.value.codigo]
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("table", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.id,
                        onClick: ($event: any) => (getLogdemo(elm.compania, elm.agencia, elm.fecha, elm.almacen, elm.codigo, elm.documento, elm.id)),
                        class: _normalizeClass({ 'table-primary': elm.id === id_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_cliente), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_codigo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.documento), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.guia_despacho), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_llegada), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.hora_llegada), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.valor), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 10, _hoisted_38))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("table", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logdemo.value, (elm1) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm1.secuencia,
                        onClick: ($event: any) => (true),
                        class: _normalizeClass({ 'table-primary': elm1.id === de_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm1.secuencia), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.orden_produccion), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.pallets), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.cajas), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.peso), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.monto), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.nom_status), 1)
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "col div-buttom",
              style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px","height":"300px"}
            }, [
              _createElementVNode("div", { class: "btn-group2" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Entrada
                }, "Movimientos"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Calcular
                }, "Calcular"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Despachar
                }, "Entrega"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Listar
                }, "Reporte"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Auxiliar
                }, "Auxiliar")
              ])
            ])
          ])
        ]),
        (_unref(btnIn))
          ? (_openBlock(), _createBlock(InCuartoFrio, {
              key: 0,
              fecha: _unref(fecha),
              btnIn: _unref(btnIn),
              onInsertProps: insertPropsValue
            }, null, 8, ["fecha", "btnIn"]))
          : _createCommentVNode("", true),
        (_unref(btnEx))
          ? (_openBlock(), _createBlock(ExCuartoFrio, {
              key: 1,
              btnEx: _unref(btnEx),
              onInsertProps: ExcelPropsValue
            }, null, 8, ["btnEx"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})